import { ChainId } from '../web3.types'
import { getChainConfig } from './chain.utils'

export function getBlockExplorerName(chain?: ChainId) {
  const _chain = chain || ChainId.Mainnet
  return getChainConfig(_chain).blockExplorer.name
}

function getBlockExplorerUrl(chain: ChainId) {
  return getChainConfig(chain).blockExplorer.baseUrl.replace(/\/+$/, '')
}

export function getBlockExplorerTxUrl(txHash: string, chain?: ChainId) {
  const _chain = chain || ChainId.Mainnet
  return `${getBlockExplorerUrl(_chain)}/tx/${txHash}`
}

export function getBlockExplorerAddressUrl(address: string, chain?: ChainId) {
  const _chain = chain || ChainId.Mainnet
  return `${getBlockExplorerUrl(_chain)}/address/${address}`
}
